/**
 * Created by jv on 15/03/2017.
 */
/**
 * Created by jv on 26/01/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");
const ElementCreator = require("Sources/components/element-creator");
const DataFilter = require("Sources/components/data-filter");
const Tooltip = require("Sources/components/tooltip");

require("Styles/components/catalog.scss");

module.exports = class CatalogTemplate
{
  constructor(options)
  {
    /*
     * options.appendTo
     * options.catalog (Catalog object [models/store/catalog.js])
     *
     * options.addToCart(key)
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.appendTo = $(options.appendTo);
    this.catalog = options.catalog;
    this.cart = options.cart;

    this._filteredArticles = this.catalog.articles.slice(0);

    this.addToCart = options.addToCart;
    this.onShowDetails = options.onShowDetails;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.catalogWrapperEl =$("<div class='catalog-grid-wrapper'></div>");
      this.appendTo.append(this.catalogWrapperEl);

      this.renderCatalog();

      this._initialized = true;
    }
  }

  refresh()
  {
    this.renderCatalog();
  }

  reload(catalog)
  {
    this.catalog = catalog;
    this.refresh();
  }

  reset()
  {
    this._filteredArticles = this.catalog.articles.slice(0);
    this.refresh();
  }

  sort(options)
  {
    options.sortType = utils.isNull(options.sortType) ? "" : options.sortType;
    options.asc = utils.isBoolean(options.asc) ? options.asc : false;

    this._filteredArticles = DataFilter.sort(this.catalog.articles, options.sortType, options.sortKey, options.asc);
    this.refresh();
  }

  filter(options)
  {
    /*
     * options.property = null
     * options.filterValues = []
     * options.exact = false
     * options.propertyType = "undefined"
     */

    options = utils.isNotNull(options) ? options : {};
    options.property = utils.isUndefined(options.property) ? null : options.property;
    options.filterValues = utils.isArray(options.filterValues) ? options.filterValues : [];
    options.exact = utils.isBoolean(options.exact) ? options.exact : false;

    this._filteredArticles = DataFilter.filter(this.catalog.articles, options.property, options.filterValues, options.exact, options.propertyType);
    this.refresh();
  }

  get visibleArticles()
  {
    return utils.isArray(this._filteredArticles) ? this._filteredArticles.length : 0;
  }

  isSameType(type1, type2)
  {
    if (type1 === "license_bibnet_picturebooks" && type2 === "license_bibnet_avi")
      return true;

    return type1 === type2;
  }

  getTypeLocalization(type)
  {
    if (type === "license_bibnet_picturebooks" || type === "license_bibnet_avi")
      return LanguageManager.getValueForKey("store.catalog.article.type.subscription");

    return LanguageManager.getValueForKey("store.catalog.article.type." + type);
  }

  renderCatalog()
  {
    this.catalogWrapperEl.empty();

    var currentType = null;

    for(var i = 0; i < this._filteredArticles.length; i++)
    {
      if (!this.isSameType(currentType, this._filteredArticles[i].type))
      {
        currentType = this._filteredArticles[i].type;
        this.catalogWrapperEl.append($("<div class='catalog-sub-title'>" + this.getTypeLocalization(currentType) + "</div>"));
      }

      this.catalogWrapperEl.append(this.renderCatalogItem(this._filteredArticles[i]));
    }

    for(var j = 0; j < this._filteredArticles.length; j++)
    {
      var article = this._filteredArticles[j];
      if(!article.purchasable && !utils.isNullOrEmpty(article.remark))
      {
        Tooltip.create({
          selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
          content: article.remark,
          placement: "auto"
        });
      }
      else if(article.alreadyOwned)
      {
        Tooltip.create({
          selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
          content: LanguageManager.getValueForKey("store.catalog.article.already_owned"),
          placement: "auto"
        });
      }
      else if(this.cart.containsArticle(article.key) && article.purchaseOnce)
      {
        Tooltip.create({
          selector: this.catalogWrapperEl.find(".catalog-article[data-catalog-article='" + article.key + "']").find(".article-add .add-article-btn"),
          content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
          placement: "auto"
        });
      }
    }

    this.setUpEventListeners();
  }

  setUpEventListeners()
  {
    var that = this;

    that.catalogWrapperEl.find(".catalog-article .article-add .add-article-btn").not(".disabled").off("click").on("click", function(e)
    {
      var $this = $(this);
      var articleKey = $(this).closest(".catalog-article").attr("data-catalog-article");

      var article = that.catalog.getArticleForKey(articleKey);

      if(utils.isNotNull(article) && !article.alreadyOwned)
      {
        if(article.purchaseOnce)
        {
          $this.addClass("disabled").off();

          Tooltip.create({
            selector: $this,
            content: LanguageManager.getValueForKey("store.catalog.article.purchase_once"),
            placement: "auto"
          });
        }

        if(utils.isFunction(that.addToCart))
        {
          that.addToCart(articleKey);
        }
      }
    });

    that.catalogWrapperEl.find(".catalog-article .article-image img, .catalog-article .article-title").off("click").on("click", function(e)
    {
      var articleKey = $(this).closest(".catalog-article").attr("data-catalog-article");

      var article = that.catalog.getArticleForKey(articleKey);

      if (article.type !== "free_download")
      {
        if (utils.isFunction(that.onShowDetails))
        {
          that.onShowDetails(article);
        }
      }
    });
  }

  renderCatalogItem(article)
  {
    var articleEl = $("<div class='catalog-article' data-catalog-article='" + article.key + "'></div>");

    articleEl.append(this.createArticleImage(article));

    var infoWrapper = $("<div class='article-info-wrapper'></div>").append(this.createArticleInfo(article));
    //var alignBottom = $("<div class='align-bottom'></div>").append(this.createArticlePrice(article)).append(this.createArticleAddToCart(article));
    var alignBottom = $("<div class='align-bottom'></div>");

    if (article.type !== "free_download")
    {
      alignBottom.append(this.createArticlePrice(article));
      alignBottom.append(this.createArticleAddToCart(article))
    }
    else
    {
      alignBottom.append(this.createArticleDownload(article));
    }

    infoWrapper.append(alignBottom);
    articleEl.append(infoWrapper);

    return articleEl;
  }

  createArticleImage(article)
  {
    var articleImage = ElementCreator.createStringElement({
      tagName: "img",
      attributes: [
        { name: "src", value: article.image }
      ]
    });

    var articleImageWrapper = ElementCreator.createStringElement({
      classNames: [ "article-image" ],
      innerHTML: articleImage
    });

    return articleImageWrapper;
  }

  createArticleInfo(article)
  {
    var infoEl = $("<div class='article-info'></div>");

    if(!utils.isNullOrEmpty(article.title))
    {
      infoEl.append("<div class='article-title'>" + article.title + "</div>");
    }

    if(!utils.isNullOrEmpty(article.author))
    {
      infoEl.append("<div class='article-author'>" + article.author + "</div>");
    }

    if(!utils.isNullOrEmpty(article.publisher))
    {
      infoEl.append("<div class='article-publisher'>" + article.publisher + "</div>");
    }

    if(!utils.isNullOrEmpty(article.age))
    {
      infoEl.append("<div class='article-age'>" + article.age + "</div>");
    }

    if (!utils.isNullOrEmpty(article.remark))
    {
      if (article.purchasable)
      {
        infoEl.append("<div class='article-remark-purchasable'>" + article.remark + "</div>");
      }
      /*
      else
      {
        infoEl.append("<div class='article-remark-unpurchasable'>" + article.remark + "</div>");
      }*/
    }

    // if(!utils.isNullOrEmpty(article.age))
    // {
    //   infoEl.append("<div class='article-age'>" + article.age + "</div>");
    // }

    return infoEl;
  }

  createArticlePrice(article)
  {
    var priceEl = ElementCreator.createStringElement({
      classNames: [ "price" ],
      innerHTML: this.catalog.currency + " " + article.priceVat
    });

    var priceExtraEl = ElementCreator.createStringElement({
      classNames: [ "vat" ],
      innerHTML: LanguageManager.getValueForKey("store.catalog.vat.inclusive") + " " + article.vatPercentage + "% " + LanguageManager.getValueForKey("store.catalog.vat")
    });

    var priceWrapperEl = ElementCreator.createStringElement({
      classNames: [ "article-price" ],
      innerHTML: priceEl + priceExtraEl
    });

    return priceWrapperEl;
  }

  createArticleMoreInfo(article)
  {
    var moreInfoEl = ElementCreator.createStringElement({

    });

    return "";
  }

  createArticleAddToCart(article)
  {
    var disabledClass = "";

    if(!article.purchasable || article.alreadyOwned || (utils.isNotNull(this.cart) && this.cart.containsArticle(article.key) && article.purchaseOnce))
    {
      disabledClass = "disabled"
    }

    var addToCartLinkEl = ElementCreator.createStringElement({
      tagName: "button",
      classNames: [ "btn", "btn-main", "no-icon", "add-article-btn", disabledClass ],
      attributes: [
        { name: "data-article-key", value: article.key },
        { name: "type", value: "button" }
      ],
      innerHTML: LanguageManager.getValueForKey("store.catalog.add_to_cart")
    });

    var addToCartWrapperEl = ElementCreator.createStringElement({
      classNames: [ "article-add" ],
      innerHTML: addToCartLinkEl
    });

    return addToCartWrapperEl;
  }

  createArticleDownload(article)
  {
    var downloadLinkEl = ElementCreator.createStringElement({
      tagName: "button",
      classNames: [ "btn", "btn-main", "no-icon", "download-article-btn"],
      attributes: [
        { name: "data-article-key", value: article.key },
        { name: "type", value: "button" }
      ],
      innerHTML: LanguageManager.getValueForKey("store.catalog.download")
    });

    var wrapperEl = ElementCreator.createStringElement({
      tagName: "a",
      classNames: [ "article-download" ],
      attributes: [
        { name: "href", value: article.download },
        { name: "target", value: "_blank" }
        ],
      innerHTML: downloadLinkEl
    });

    return wrapperEl;
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/store-catalog-grid-library.template.js